<form [formGroup]="definitionForm" (ngSubmit)="onSave()">
    <div class="definition-main-container">
        <div class="definition-instructions-container">
            <r1-compass-lib-instructions headerText="Definition"
                >Provide a name and description for the Template Criteria for reference later. Then select the
                Salesforce Target Object which is the object for which the play will create Recommendations. Required
                fields are marked with an astrisk*.
            </r1-compass-lib-instructions>
        </div>
        <div class="definition-fields-container">
            <div class="form-row-container">
                <span class="field-row-name">Template Criteria Internal Name *</span>
                <mat-form-field class="field-wrapper">
                    <mat-label>Template Criteria Name</mat-label>
                    <input matInput type="text" [formControl]="definitionForm.controls.name" />
                    @if (definitionForm.controls.name.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-row-container">
                <span class="field-row-name">Template Criteria Internal Description</span>
                <mat-form-field class="field-wrapper">
                    <mat-label>Template Criteria Description</mat-label>
                    <textarea
                        id="descriptionTextArea"
                        matInput
                        rows="3"
                        [formControl]="definitionForm.controls.description"></textarea>
                </mat-form-field>
            </div>
            <div class="form-row-container">
                <span class="field-row-name">Salesforce Target Object *</span>
                <mat-form-field class="field-wrapper">
                    <mat-label>Salesforce Target Object</mat-label>
                    <mat-select [formControl]="definitionForm.controls.salesforceTargetId">
                        @for (option of salesforceTargetOptions; track option) {
                            <mat-option [value]="option.id">{{ option.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="footer-container">
        <button mat-raised-button color="primary" [disabled]="disableSave()" type="submit">Save</button>
    </div>
</form>
